var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 29,
    viewBox: "0 0 36 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04395 28L32.1689 1",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3735 25.0751C14.83 25.5297 16.3478 25.7573 17.8735 25.7501C24.0235 25.8551 30.2635 21.5351 34.1035 17.2901C34.5178 16.8345 34.7473 16.2408 34.7473 15.6251C34.7473 15.0093 34.5178 14.4157 34.1035 13.9601C32.715 12.4254 31.1718 11.038 29.4985 9.82007",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5088 7.40496C23.1482 6.18034 20.5329 5.52779 17.8738 5.49996C11.8738 5.39496 5.57377 9.62496 1.64377 13.96C1.22953 14.4156 1 15.0092 1 15.625C1 16.2407 1.22953 16.8344 1.64377 17.29C3.77359 19.6709 6.27004 21.6964 9.03877 23.29",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3739 19.105C12.5602 17.9761 12.1815 16.5914 12.3074 15.2055C12.4333 13.8196 13.0555 12.5258 14.0593 11.5621C15.0632 10.5984 16.3813 10.0296 17.7712 9.96029C19.161 9.89101 20.5292 10.3259 21.6239 11.185",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4985 15.625C23.4985 16.3637 23.353 17.0951 23.0704 17.7776C22.7877 18.4601 22.3733 19.0801 21.851 19.6025C21.3287 20.1248 20.7086 20.5391 20.0261 20.8218C19.3437 21.1045 18.6122 21.25 17.8735 21.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.4c4c6f73bee902270dd3a199f419a7d2.svg";
export { ForwardRef as ReactComponent };